// DO NOT EDIT manually
// This file has edited by setConfig.sh file

// version : web version (from package.json)
// build time : time the build was performed
// build commit : Commit value of GIT

export default {
    version: '1.5.8',
    build_time: '2025-12-16T12:45:10',
    build_commit_hash: '41e8fb62c6649b995d54aeaf775ffe25333b5053',
};
